import axios from 'axios';
import urlconfig from './urlConfig';
const passkey='uat'
const envConfig = urlconfig(passkey);
console.log(envConfig)

const api = axios.create({
  baseURL: envConfig.apiurl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;